import { useTranslations } from 'next-intl';
import React from 'react';

import { FinishRegistrationForm } from '../../confirm-account/components/FinishRegistrationForm';

import { Button } from '@components/Form';
import Separator from '@components/simple/Separator';
import Tooltip from '@components/Tooltip';

interface ContinueRegistrationV2Props {
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
  formDisabled: boolean;
  cancelClicked: boolean;
}

const TooltipButton = ({ onCancel, isLoading, disabled }: { onCancel: () => any, isLoading: boolean, disabled: boolean }) => {
  const t = useTranslations('auth.registerV2');
  return <div className='flex flex-col items-center'>
    <Button
      onClick={onCancel}
      disabled={disabled}
      loading={isLoading}
      className='flex w-full items-center justify-center block max-w-96 h-[42px] rounded-3xl border bg-grenade px-4 py-2 text-sm text-center transition-colors text-white hover:text-white font-bold hover:bg-blue disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-blue dark:bg-white dark:text-premium-900 dark:hover:bg-premium-900 dark:hover:text-white dark:disabled:hover:bg-white dark:disabled:hover:text-premium-900 w-[200px]'
    >
      {t('skip')}*
    </Button>
  </div>;
}

const ContinueRegistrationV2: React.FC<ContinueRegistrationV2Props> = ({ onSubmit, onCancel, formDisabled, cancelClicked }) => {
  const t = useTranslations('auth');

  return (
    <div>
      <FinishRegistrationForm formDisabled={formDisabled} title={t('registerV2.continueRegistrationTitle')} onSubmit={onSubmit} />
      {onCancel && (
        <>
          <Separator borderWidth={1} className='my-4'>{t('label.or')}</Separator>
          <div className='hidden lg:block'>
            <Tooltip
              tooltipMessageClassName='flex items-center'
              title={<TooltipButton onCancel={onCancel} isLoading={cancelClicked && formDisabled} disabled={formDisabled} />}
              content={t('registerV2.skipTooltip')}
            />
          </div>
          <div className='block lg:hidden'>
            <TooltipButton onCancel={onCancel} isLoading={cancelClicked && formDisabled} disabled={formDisabled} />
            <p className='text-[10px] text-center mt-2'>* - {t('registerV2.skipTooltip')}</p>
          </div>
        </>
      )}</div>
  );
};

export default ContinueRegistrationV2;